import React from 'react';
import {createPortal} from 'react-dom';
import PersonalMemoMenuItem from '../../common/personalMemos/PersonalMemoMenuItem';

type Props = {
  chatHeaderMenuOpen: boolean; chatHeaderMenuPosition: {left: number; top: number} | null;
  closeChatHeaderMenu: () => void; openMaterialsModal: () => void; openAlbumModal: () => void;
  openLinksModal: () => void; openMediaModal: () => void;
  materialBadge: {count: number; tone: string}; albumBadge: {count: number; tone: string};
};

export default function ArtistEventChatHeaderMenu({chatHeaderMenuOpen,chatHeaderMenuPosition,closeChatHeaderMenu,openMaterialsModal,openAlbumModal,openLinksModal,openMediaModal,materialBadge,albumBadge}: Props){
  if(!chatHeaderMenuOpen||!chatHeaderMenuPosition||typeof document==='undefined')return null;
  return createPortal(
<div
                            className="event-header-menu event-header-menu--floating"
                            role="menu"
                            style={{
                              left: `${chatHeaderMenuPosition.left}px`,
                              top: `${chatHeaderMenuPosition.top}px`,
                            }}
                            onClick={(event) => event.stopPropagation()}
                          >
                            <PersonalMemoMenuItem onAfterOpen={closeChatHeaderMenu} />
                              <button
                              type="button"
                              role="menuitem"
                              onClick={() => {
                                openMaterialsModal();
                                closeChatHeaderMenu();
                              }}
                            >
                              <i className="fa-solid fa-folder-open" aria-hidden="true"></i>
                              <span>イベント資料</span>
                              {materialBadge.count > 0 ? (
                                <span className="event-header-menu-badge">
                                  <span className={`event-header-menu-dot is-${materialBadge.tone}`} aria-hidden="true" />
                                  <span>{materialBadge.count}</span>
                                </span>
                              ) : null}
                            </button>
                            <button
                              type="button"
                              role="menuitem"
                              onClick={() => {
                                openAlbumModal();
                                closeChatHeaderMenu();
                              }}
                            >
                              <i className="fa-solid fa-images" aria-hidden="true"></i>
                              <span>イベントアルバム</span>
                              {albumBadge.count > 0 ? (
                                <span className="event-header-menu-badge">
                                  <span className={`event-header-menu-dot is-${albumBadge.tone}`} aria-hidden="true" />
                                  <span>{albumBadge.count}</span>
                                </span>
                              ) : null}
                            </button>
                            <button
                              type="button"
                              role="menuitem"
                              onClick={() => {
                                openLinksModal();
                                closeChatHeaderMenu();
                              }}
                            >
                              <i className="fa-solid fa-link" aria-hidden="true"></i>
                              <span>リンク</span>
                            </button>
                            <button
                              type="button"
                              role="menuitem"
                              onClick={() => {
                                openMediaModal();
                                closeChatHeaderMenu();
                              }}
                            >
                              <i className="fa-solid fa-photo-film" aria-hidden="true"></i>
                              <span>写真・ファイル</span>
                            </button>
                          </div>,document.body);
}
